<template>
  <tr class="row-details">
    <td class="v-align-middle"  colspan="6" v-if="readyToRender">
      <div class="mf_container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <div class="mf-address">
          <div class="mf-address-head">
            <h4>Adresse(s) concernée(s)</h4>
          </div>

          <validation-address :address="validationRequestable"></validation-address>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { apiV2 } from 'store/api'
import Customer from "./ValidationRequestable/CustomerV2"
import ValidationAddress from "./ValidationRequestable/AddressV2"

export default {
  name:"MailForward",

  props:["validationRequestId", "isDetails"],

  components:{
    Customer,
    ValidationAddress
  },

  data() {
    return {
      validationRequest: null
    }
  },

  computed:{
    readyToRender() {
      return this.validationRequest != null
    },

    customer() {
      return this.validationRequest.included.customer
    },

    validationRequestable() {
      return this.validationRequest.included.validation_requestable
    }
  },

  created() {
    const params = {
      with: 'customer,validation_requestable'
    }

    apiV2.getValidationRequest(this.validationRequestId, params)
      .then((response) => this.validationRequest = response.data.data)
  }
}
</script>

<style scoped>
.mf_container {
  display: flex;
}

.mf_container > div { margin-right: 15px; }
.mf_container > div:last-child { margin-right: 0; }

.mf-address {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/MailForward.vue